import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import CommonTable, { ITableColumn } from '@/components/common/CommonTable';
import FilterComponent from '@/components/common/FilterComponent';
import MainHeading from '@/components/common/MainHeading';
import ViewIcon from '@/components/Icons/ViewIcon';
import CardLayout from '@/components/Layout/CardLayout';
import Layout from '@/components/Layout/Layout';
import useFilter from '@/hooks/useFilter';
import { IFilterSideBarForm, IPageInfo } from '@/interfaces/common.model';
import { IDepartment, ISite } from '@/interfaces/user.model';
import { RootState } from '@/redux/store';
import { calculateDaysDifference } from '@/utility/CommonFunctions';
import {
  getFilterUrl,
  orderByList,
  showToastNotification,
} from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
interface IPagination extends IPageInfo {
  count: number;
  searchQuery: string;
}
interface IWfhPageState {
  oDStatus: string;
  sortByDate: string[] | string;
  tableLoader: boolean;
}
export interface ITeamWfh {
  user: {
    name: string;
    profilePhoto: string;
    department: IDepartment;
    site: ISite;
    usersites: {
      site: { name: string };
    };
  };
  id: string;
  createdAt: string;
  startDate: string;
  wfhDuration: string;
  endDate: string;
  status: string;
}

export interface ITeamWfhResponse {
  status: boolean;
  data: { pageInfo: IPageInfo; odRequest: ITeamWfh[] };
}

export interface IWfhSortList {
  wfhStatus: (
    | { value: string; label: string }
    | { value: number; label: string }
  )[];
}
export interface IWFHTableData {
  id: string;
  index: number;
  empNameWithImage: string;
  employeeDept: string;
  siteName: string;
  days: number | string;
  appliedOn: string;
  startDate: string;
  endDate: string;
  status: string;
}
interface IState {
  wfhList: IWFHTableData[];
}
const TeamWfh = () => {
  const filterDetails = useSelector(
    (state: RootState) => state?.user?.filtersStates,
  );
  const tableView = useSelector((state: RootState) => state?.user?.tableView);
  const navigate = useNavigate();
  const [state, setState] = useState<IState>({
    wfhList: [],
  });
  const [pagination, setPagination] = useState<IPagination>({
    currentPage: 1,
    count: 0,
    searchQuery: '',
    totalPages: 0,
  });
  const [pageStates, setPageStates] = useState<IWfhPageState>({
    oDStatus: '',
    sortByDate: [
      moment().startOf('month').format('YYYY-MM-DD'),
      moment().endOf('month').format('YYYY-MM-DD'),
    ],
    tableLoader: false,
  });

  const tableHeading: ITableColumn<IWFHTableData>[] = [
    { value: 'index', label: '#' },
    { value: 'empNameWithImage', label: 'Employee' },
    { value: 'employeeDept', label: 'Department.' },
    { value: 'siteName', label: 'Office' },
    { value: 'appliedOn', label: 'Appllied Date' },
    { value: 'startDate', label: 'Start Date' },
    { value: 'endDate', label: 'End Date' },
    { value: 'days', label: 'Days' },
    { value: 'status', label: 'Status' },
  ];

  useEffect(() => {
    getOdRequest();
  }, [
    pageStates?.sortByDate,
    pagination?.currentPage,
    // pageStates.user,
    pagination?.searchQuery,
    // pageStates.siteId,
    pageStates?.oDStatus,
    // pageStates?.staffType,
    filterDetails?.pageSize,
    filterDetails?.orderBy,
  ]);

  const getOdRequest = async () => {
    const filter = {
      pageNumber: pagination?.currentPage,
      pageSize: filterDetails?.pageSize,
      startDate: pageStates?.sortByDate[0],
      endDate: pageStates?.sortByDate[1],
      search: pagination.searchQuery,
      orderBy: filterDetails?.orderBy,
      status: pageStates?.oDStatus,
    };
    try {
      const API = API_URL + API_ENDPOINT?.getWfh + '?' + getFilterUrl(filter);
      setPageStates((pre) => ({
        ...pre,
        tableLoader: true,
      }));
      const res: ITeamWfhResponse = await callApi(API, {
        method: 'GET',
      });
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        console.log(res);
        const newData = res?.data?.odRequest?.map((item, index) => {
          const days =
            Number(
              calculateDaysDifference(item?.startDate, item?.endDate, 'number'),
            ) || 0;
          const result =
            item?.wfhDuration == 'firstHalf' ||
            item?.wfhDuration == 'secondHalf'
              ? days * 0.5
              : days;
          return {
            ...item,
            id: item?.id,
            index: index,
            empNameWithImage:
              item?.user?.name + '##' + item?.user?.profilePhoto,
            employeeDept: item?.user?.department?.name ?? '--',
            officeName: item?.user?.site?.name,
            siteName: item?.user?.site?.name ?? '--',
            days: result ? Number(result) : '--',
            appliedOn: moment(item?.createdAt).format('DD/MM/YYYY'),
            startDate: moment(item?.startDate).format('DD/MM/YYYY'),
            endDate: moment(item?.endDate).format('DD/MM/YYYY'),
            status: item?.status,
          };
        });
        setState((pre) => ({
          ...pre,
          wfhList: newData,
        }));
        setPagination((pre) => ({
          ...pre,
          count: res?.data?.pageInfo?.total ?? 0,
          totalPages: res?.data?.pageInfo?.totalPages ?? 0,
        }));
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
    }
  };

  const dateChangeHandler = (Dates: Date[]) => {
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000,
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000,
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    if (formattedDate !== null) {
      setPageStates((prevState) => ({
        ...prevState,
        sortByDate: formattedDate,
      }));
    } else {
      setPageStates((prevState) => ({ ...prevState, sortByDate: '' }));
    }
  };

  const handleData = (data: Partial<IFilterSideBarForm> | null) => {
    if (data) {
      setPageStates((pre) => ({
        ...pre,
        ...{ oDStatus: data?.oDStatus ?? '' },
      }));
      setPagination((prev) => ({
        ...prev,
        currentPage: 1,
      }));
    }
  };

  const wfhSortList: IWfhSortList = {
    wfhStatus: [
      { value: '', label: 'Select Status' },
      { value: 1, label: 'Approved' },
      { value: 0, label: 'Pending' },
      { value: 2, label: 'Rejected' },
    ],
  };

  const {
    handleSearchChange,
    orderByHandler,
    pageChangeHandler,
    handleChangePageSize,
  } = useFilter(pagination, setPagination);

  const ActionData = [
    {
      label: 'View',
      className: 'btn btn-link',
      icon: <ViewIcon />,
      title: 'view',
      clickHandler: (data: IWFHTableData) =>
        navigate(`${RoutesLink?.wfhTeamRequestDetail}/${data?.id}`),
    },
  ];

  return (
    <Layout>
      <div className="content">
        <MainHeading
          title={'Team WFH Request'}
          dateChangeHandler={dateChangeHandler}
          showDefaultDate={true}
        />
        <CardLayout cardStyle=" mb-4" isGrid={tableView === 'grid'}>
          <FilterComponent
            searchPlaceHolder={'Search'}
            handleSearch={handleSearchChange}
            orderByList={orderByList}
            orderByHandler={orderByHandler}
            sortHandler={handleData}
            filterArray={{
              isShow: true,
            }}
            isGrid={false}
            wfhStatus={wfhSortList}
          />
          <CommonTable<IWFHTableData>
            tableHeading={tableHeading}
            ActionData={ActionData}
            tableData={state?.wfhList}
            count={pagination?.count}
            currentPage={pagination?.currentPage}
            pageSize={filterDetails?.pageSize}
            totalPages={pagination?.totalPages}
            isLoading={pageStates?.tableLoader}
            pageChangeHandler={pageChangeHandler}
            handleChangePageSize={handleChangePageSize}
          />
        </CardLayout>
      </div>
    </Layout>
  );
};

export default TeamWfh;
